import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CommunityGuard } from './guard/community.guard';
import { NewCommunityPage } from './modules/my-communities/page/new-community/new-community.page';
import { SupportTicketPage } from './modules/support/page/support-ticket/support-ticket.page';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'new-community',
    component: NewCommunityPage
  },
  {
    path: 'view-ticket/:guid',
    component: SupportTicketPage
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then( m => m.AuthModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/my-communities/home.module').then( m => m.HomeModule)
  },
  {
    path: 'content',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/content/content.module').then( m => m.ContentModule)
  },
  {
    path: 'events',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/event/event.module').then( m => m.EventModule)
  },
  {
    path: 'users',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/user/user.module').then( m => m.UserModule)
  },
  {
    path: 'fundraising',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/fundraising/fundraising.module').then( m => m.FundraisingModule)
  },
  {
    path: 'marketplace',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/marketplace/marketplace.module').then( m => m.MarketplaceModule)
  },
  {
    path: 'news',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/post/post.module').then( m => m.PostModule)
  },
  {
    path: 'community',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/community/community.module').then( m => m.CommunityModule)
  },
  {
    path: 'engagement',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/engagement/engagement.module').then( m => m.EngagementModule)
  },
  {
    path: 'memberships',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/membership/membership.module').then( m => m.MembershipModule)
  },
  {
    path: 'surveys',
    canActivate: [CommunityGuard],
    loadChildren: () => import('./modules/survey/survey.module').then( m => m.SurveyModule)
  },
  {
    // community is optional for support page, i.e. launch admins can see outside of community  
    path: 'support',
    loadChildren: () => import('./modules/support/support.module').then( m => m.SupportModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
